import _slicedToArray from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useEffect, useRef, useState } from 'react';
var LazyLoadedComponent = function LazyLoadedComponent(props) {
  var lazyLoading = props.lazyLoading,
    _props$as = props.as,
    as = _props$as === void 0 ? 'section' : _props$as,
    id = props.id,
    _props$rootMargin = props.rootMargin,
    rootMargin = _props$rootMargin === void 0 ? '250px' : _props$rootMargin,
    onLoad = props.onLoad,
    className = props.className,
    children = props.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loaded = _useState2[0],
    setLoaded = _useState2[1];
  var componentRef = useRef(null);
  useEffect(function () {
    if (!lazyLoading || !componentRef.current) return;
    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setLoaded(true);
          onLoad === null || onLoad === void 0 || onLoad();
          obs.disconnect();
        }
      });
    }, {
      rootMargin: rootMargin,
      threshold: 0
    });
    observer.observe(componentRef.current);
    return function () {
      return observer.disconnect();
    };
  }, [lazyLoading, onLoad, rootMargin]);
  var CustomTag = as;
  return React.createElement(CustomTag, {
    ref: componentRef,
    id: id,
    className: "".concat(loaded ? 'loaded' : '', " ").concat(className || '').trim()
  }, children);
};
export default LazyLoadedComponent;